export const inventoryProductIdToVariantId = (inventoryProductId: string) => {
    // 先頭8文字を抜き出して16進数として整数化
    const intValue = parseInt(inventoryProductId.slice(0, 8), 16);
    return (intValue % 2) + 1;
}
